// Authed User Actions Types
export const SET_AUTHED_USER = 'SET_AUTHED_USER';
export const REMOVE_AUTHED_USER = 'REMOVE_AUTHED_USER';
export const USER_ADD_QUESTION = 'USER_ADD_QUESTION';
export const USER_ANSWER_QUESTION = 'USER_ANSWER_QUESTION';

// Users Actions Types
export const RECEIVE_USERS = 'RECEIVE_USERS';

// Questions Actions Types
export const RECEIVE_QUESTIONS = 'RECEIVE_QUESTIONS';
export const ADD_QUESTION = 'ADD_QUESTION';
export const ANSWER_QUESTION = 'ANSWER_QUESTION';